var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.001,
    viewBox: "0 0 24 24.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ee5050;}.b{fill:none;stroke:#f4f6f9;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.486,3.515a12,12,0,1,0,0,16.971,12,12,0,0,0,0-16.971Z",
    transform: "translate(23)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.491 4.491)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.732,4.781,0,2.391,2.732,0",
    transform: "translate(7.513 10.245)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.342,0A3.415,3.415,0,0,1,2.927,3.415H0",
    transform: "translate(8.684 9.221)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.732,4.781,0,2.391,2.732,0",
    transform: "translate(7.513 10.245)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.342,0A3.415,3.415,0,0,1,2.927,3.415H0",
    transform: "translate(8.684 9.221)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.14,0l-.7,3.561L0,2.391",
    transform: "translate(8.448 1.696)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,.458a3.414,3.414,0,0,1,4.665,1.25L6.129,4.244",
    transform: "translate(5.17 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,1.171,3.436,0l.7,3.561",
    transform: "translate(0 5.446)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.708,7.2A3.414,3.414,0,0,1,.458,2.535L1.921,0",
    transform: "translate(0.929 6.46)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.20b5d26a135c8b17eb62be5bef25ecaa.svg";
export { ForwardRef as ReactComponent };